import { render, staticRenderFns } from "./file.vue?vue&type=template&id=1cc00ce8&scoped=true&"
import script from "./file.vue?vue&type=script&lang=ts&"
export * from "./file.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc00ce8",
  null
  
)

export default component.exports